export const LAST_VISITED_STEP_KEY = 'reorder-pro:last-visited-step';
